var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page-content',[_c('app-title',{attrs:{"text":"Módulo de Logistica"}}),_vm._v(" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }